import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  Button,
  Chip,
} from "@mui/material";
import MapIcon from "@mui/icons-material/Map";
import RouteIcon from "@mui/icons-material/Route";
import MonitorIcon from "@mui/icons-material/Monitor";
import {
  Grid2,
  LinearProgress,
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import DownloadIcon from "@mui/icons-material/Download";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import HubIcon from "@mui/icons-material/Hub";
import LogoutIcon from "@mui/icons-material/Logout";
import FileUploadRut from "../../../components/formularios/FrmsUpFiles/FileUploadRut.jsx";
import FileUploadDocComercio from "../../../components/formularios/FrmsUpFiles/FileUploadDocComercio.jsx";
import FileUploadDocSii from "../../../components/formularios/FrmsUpFiles/FileUploadDocSii.jsx";
import FileUploadDocEbiexComercio from "../../../components/formularios/FrmsUpFiles/FileUploadDocEbiexComercio.jsx";
import FileUploadPatente from "../../../components/formularios/FrmsUpFiles/FileUploadPatente.jsx";
import FileUploadLogo from "../../../components/formularios/FrmsUpFiles/FileUploadLogo.jsx";
import Fromcompanynew from "../../../components/formularios/Fromcompany/Fromcompanynew.jsx";
import Fromcompanywiew from "../../../components/formularios/Fromcompany/Fromcompanywiew.jsx";
import Moment from "moment";
import useGlobalConfig from "../../../hooks/globalConfig.js";
import { useLoadScript } from "@react-google-maps/api";
import { UserContext } from "../../../context/CurrentUserProvider.jsx";
import FromFindCompany from "./FromFindCompany/FromFindCompany.jsx";
import { getRequestAccessToCompany } from "../../../utils/requestAccessToCompany.jsx";
import CompanyDetailsCard from "../Micuenta/CompanyDetailsCard.jsx";
import { useOrders } from "../../../hooks/useOrdersProviders/OrdersContext.jsx";
import { Block } from "@mui/icons-material";
import Reports from "../Reports/Reports.jsx";
import Direcciones from "../Direcciones/Direcciones.jsx";
import { useNavigate } from "react-router-dom";
import CompanySelector from "./CompanySelector.jsx";
import Configuraciones from "../Configuraciones/Configuraciones.jsx";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "../../../firebase.js";

const libraries = ["places"];

const VIEWS = {
  DESK: "Escritorio",
  DOWNLOADS: "Descargas",
  ADDR: "Direcciones",
  ACCOUNT: "Cuenta",
  INTEGRATIONS: "Integraciones",
};

const DRAWER_WIDTH = 240;

const Companies = (props) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIGOOGLEMAPS_MATRIX,
    libraries,
  });

  const { userDataContext } = useContext(UserContext);
  const { userData, companyData } = userDataContext;
  const {
    mergedOrders,
    loadingContext,
    initDate,
    endDate,
    setInitDate,
    setEndDate,
    companiesData,
    setShouldSubscribe,
  } = useOrders({
    initDateInitial: Moment().format("YYYY-MM-DD"),
    endDateInitial: Moment().format("YYYY-MM-DD"),
  });
  const { siteName } = useGlobalConfig();
  const [authorized, setAuthorized] = useState(false);
  const [viewRegister, setViewRegister] = useState(false);
  const [ViewFindCompany, setViewFindCompany] = useState(false);
  const [requestDocs, setRequestDocs] = useState([]);

  const [selectedView, setSelectedView] = useState(VIEWS.DESK);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [currentCompany, setCurrentCompany] = useState([]);
  const [selectedCompanyID, setSelectedCompanyID] = useState("");
  const [vehicles, setVehicles] = useState([]);
  const [integraciones, setIntegraciones] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    if (companyData) {
      if (!selectedCompanyID.length > 0) {
        setCurrentCompany(companyData);
        getIntegrations(companyData, companyData.id);
        console.log("companiesData , currentCompany", currentCompany);
      } else {
        let selectedComp = companiesData.filter(
          (item) => item.id === selectedCompanyID
        );

        setCurrentCompany(selectedComp[0]);
        getIntegrations(selectedComp[0], selectedComp[0].id);
      }
    }
  }, [companyData, selectedCompanyID]);

  useEffect(() => {
    if (userData) {
      const rolesAllowed = [
        process.env.REACT_APP_ADMIN,
        process.env.REACT_APP_ADMIN_COMPANY,
        process.env.REACT_APP_ADMIN_XPRESS,
      ];
      if (rolesAllowed.includes(userData.userCompanyRoll)) {
        setAuthorized(true);
      }
      getRequest(userData.uid);
      getUserPerfiles();
    }
  }, [userData]);

  useEffect(() => {
    const getVehicles = async () => {
      try {
        const vehiclesCollection = collection(db, "vehicles");
        const snapshot = await getDocs(vehiclesCollection);
        const vehiclesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const vehicleMap = Object.fromEntries(
          vehiclesData.map((vehicle) => [vehicle.id, vehicle])
        );

        setVehicles(vehicleMap);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
      }
    };

    getVehicles();
  }, []);

  useEffect(() => {}, [requestDocs]);

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const isValidCompanyDataForBranch = (data) => {
    if (!data) return false;
    const requiredFields = [
      "companyID",
      "companyName",
      "companyRut",
      "companyAddress",
      "direccion1",
      "direccion2",
      "companyComuna",
      "companyRegion",
      "companyCountry",
      "companyAdressPhone",
      "addressGeoreft",
    ];

    for (const field of requiredFields) {
      if (!data[field]) return false;
    }

    if (
      !data.addressGeoreft.latitude ||
      !data.addressGeoreft.longitude ||
      typeof data.addressGeoreft.latitude !== "number" ||
      typeof data.addressGeoreft.longitude !== "number"
    ) {
      return false;
    }

    return true;
  };

  const ensureDefaultBranch = async (companyID, companyData) => {
    console.log(
      "Asegurando sucursal por defecto para la empresa:",
      companyID,
      ensureDefaultBranch
    );
    const branchesRef = collection(
      db,
      "xpress_Companies",
      companyID,
      "branches"
    );
    const snapshot = await getDocs(branchesRef);

    const hasBranches = !snapshot.empty;

    if (!hasBranches && companyData?.isActive) {
      const defaultBranch = {
        geolocation: companyData.addressGeoreft
          ? {
              lat: companyData.addressGeoreft.latitude,
              lng: companyData.addressGeoreft.longitude,
            }
          : null,
        addressName: "Bodega Principal",
        addressOriginComment: "",
        clientNameOrigin:
          companyData.companyContacName || companyData.contactName || "",
        clientRutOrigin: companyData.companyRut,
        commerce: companyData.companyName,
        communeOrigin: companyData.companyComuna,
        communeParentOrigin: companyData.companyCity,
        company: companyData.companyName,
        companyID: companyID,
        costCenter: "1",
        countryOrigin: companyData.companyCountry,
        addressLine1Origin: companyData.direccion1,
        addressLine2Origin:
          companyData.direccion2 || companyData.companyNumAddress,
        addressLine3Origin: "N/A",
        internalPlaceName: "Casa Matriz",
        warehouseCode: companyData.int_warehouseCode || "DEFAULT",
        warehouseName: "Bodega Principal",
        regionOrigin: companyData.companyRegion,
        formattedAddressOrigin: companyData.companyAddress,
        userPhoneOrigin: companyData.companyAdressPhone,
        zonePolygon: "",
        createdAt: Date.now(),
      };

      await addDoc(branchesRef, defaultBranch);
      console.log("✅ Sucursal 'Bodega Principal' creada por defecto.");
    }
  };

  const getIntegrations = async (companyData, companyID) => {
    console.log(
      "Obteniendo integraciones para la empresa:",
      companyData,
      companyID
    );

    console.log(isValidCompanyDataForBranch(companyData));

    if (companyData?.isActive && isValidCompanyDataForBranch(companyData)) {
      await ensureDefaultBranch(companyID, companyData);
    }

    try {
      // Obtener todos los tipos de integraciones disponibles
      const tiposSnap = await getDocs(collection(db, "xpress_integrations"));
      const tiposDisponibles = tiposSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Obtener todas las instancias activas de la empresa
      const empresaRef = collection(
        db,
        "xpress_Companies",
        companyID,
        "integrations"
      );
      const instanciasSnap = await getDocs(empresaRef);

      const instancias = instanciasSnap.empty
        ? [] // No hay instancias activas, aún no han activado ninguna
        : instanciasSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

      // Unir tipos con instancias existentes (si las hay)
      const integracionesData = tiposDisponibles
        .filter((tipo) => tipo.enabled) // ← solo integraciones activas
        .sort((a, b) => (a.position || 0) - (b.position || 0)) // ← orden por posición
        .map((tipo) => {
          const instanciasDelTipo = instancias.filter(
            (inst) => inst.integrationID === tipo.integrationID
          );

          let status = "inactive";
          if (instanciasDelTipo.length > 0) {
            const connected = instanciasDelTipo.find(
              (i) => i.status === "connected"
            );
            status = connected
              ? "connected"
              : instanciasDelTipo[0].status || "unknown";
          }

          return {
            ...tipo,
            instancias: instanciasDelTipo,
            status,
          };
        });

      setIntegraciones(integracionesData);
    } catch (error) {
      console.error("❌ Error fetching integrations:", error);
    }
  };

  const getRequest = async (userId) => {
    const documents = await getRequestAccessToCompany(userId);
    setRequestDocs(documents);
  };

  const getUserPerfiles = async () => {
    console.log(userData);
  };

  const handleRequestAccess = () => {
    setTimeout(() => {
      setViewRegister(false);
    }, 2000);
    setTimeout(() => {
      setViewFindCompany(true);
    }, 1000);
    // Logic to request access to a company
  };

  const toggleChildTrigger = () => {
    setTimeout(() => {
      setViewRegister(true);
    }, 2000);
    setTimeout(() => {
      setViewFindCompany(false);
    }, 1000);
  };

  const menuItems = [
    { id: VIEWS.DESK, text: "Escritorio", icon: <DashboardIcon /> },
    { id: VIEWS.DOWNLOADS, text: "Descargas", icon: <DownloadIcon /> },
    { id: VIEWS.ADDR, text: "Sucursales", icon: <HomeWorkIcon /> },
    {
      id: VIEWS.ACCOUNT,
      text: "Configuraciones",
      icon: <AccountCircleIcon />,
    },
    { id: VIEWS.INTEGRATIONS, text: "Integraciones", icon: <HubIcon /> },
  ];

  const renderContent = () => {
    switch (selectedView) {
      case VIEWS.DOWNLOADS:
        return <Reports></Reports>;
      case VIEWS.ADDR:
        return <Direcciones currentCompany={currentCompany}></Direcciones>;
      case VIEWS.ACCOUNT:
        return (
          <Configuraciones
            userData={userData}
            companiesData={companiesData}
            currentCompany={currentCompany}
            vehicles={vehicles}
            integraciones={integraciones}
          ></Configuraciones>
        );
      case VIEWS.INTEGRATIONS:
        return <Typography>Integraciones</Typography>;
      case VIEWS.DESK:
      default:
        return (
          <Box sx={{ p: 2 }}>
            <Typography>Bienvenido al Escritorio</Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Empresa :
              </Typography>
              <CompanyDetailsCard company={currentCompany} />
              {/*
              <Typography variant="h5" sx={{ mb: 2 }}>
                Colaboraciones
              </Typography>
              <Divider sx={{ my: 2 }} />
              {companiesData ? (
                <>
                  {companiesData?.map((collab, index) => (
                    <CompanyDetailsCard key={index} company={collab} />
                  ))}
                </>
              ) : null} */}
            </Box>
          </Box>
        );
    }
  };

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  const drawer = (
    <div>
      <Toolbar sx={{ justifyContent: "center" }}>
        <CompanySelector
          companysData={companiesData}
          selectedCompanyID={selectedCompanyID}
          onChange={setSelectedCompanyID}
        />
      </Toolbar>
      <Divider />
      <List>
        {menuItems.map(({ id, text, icon }) => (
          <ListItem key={id} disablePadding>
            <ListItemButton
              selected={selectedView === id}
              onClick={() => {
                setSelectedView(id);
                if (!isMdUp) setMobileOpen(false); // cerrar en móvil
              }}
            >
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Toolbar sx={{ justifyContent: "center" }}>
        <Typography variant="h6">Accesos rápidos</Typography>
      </Toolbar>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/dashboard/guias")}>
            <ListItemIcon>
              <ShoppingBagIcon />
            </ListItemIcon>
            <ListItemText primary="Envíos" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton onClick={() => navigate("/dashboard/view-plannig")}>
            <ListItemIcon>
              <MapIcon />
            </ListItemIcon>
            <ListItemText primary="Mapa de distibución" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => navigate("/dashboard/planificacion-de-operaciones")}
          >
            <ListItemIcon>
              <RouteIcon />
            </ListItemIcon>
            <ListItemText primary="Rutas" />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => navigate("/dashboard/monitoreo-de-operaciones")}
          >
            <ListItemIcon>
              <MonitorIcon />
            </ListItemIcon>
            <ListItemText primary="Monitor avances" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  return userData ? (
    <Grid2
      sx={{
        display: "flex-colum",
        backgroundColor: "#f8f8f8",
        height: "100vh",
      }}
    >
      <Grid2 item xs={12}>
        <AppBar
          position="realative"
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            color: "#030303",
            backgroundColor: "#f8f8f8",
            width: { md: "100%" },
          }}
        >
          <Toolbar>
            {!isMdUp && (
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" noWrap>
              {selectedView}
            </Typography>
          </Toolbar>
        </AppBar>
      </Grid2>
      <Grid2 item xs={12}>
        {currentCompany ? (
          <Box
            sx={{
              display: {
                xs: "block", // pantalla extra pequeña (mobile)
                sm: "block", // pantalla pequeña (tablet)
                md: "flex", // pantalla mediana (desktop)
                lg: "flex", // pantalla grande (larger desktop)
                xl: "flex", // pantalla extra grande
              },
              mb: 1,
            }}
          >
            <Grid2
              sx={{
                width: {
                  xs: "100%", // pantalla extra pequeña (mobile)
                  sm: "100%", // pantalla pequeña (tablet)
                  md: "100%", // pantalla mediana (desktop)
                  lg: "30%", // pantalla grande (larger desktop)
                  xl: "30%", // pantalla extra grande
                },
                padding: "10px", // padding común para todos los tamaños
                maxWidth: {
                  xs: "100%", // pantalla extra pequeña (mobile)
                  sm: "100%", // pantalla pequeña (tablet)
                  md: "250px", // pantalla mediana (desktop)
                  lg: "250px", // pantalla grande (larger desktop)
                  xl: "250px", // pantalla extra grande
                },
              }}
            >
              <Card>
                <CardContent>
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Avatar
                      src={currentCompany?.companyImgLogo || ""}
                      sx={{ height: 64, mb: 2, width: 64 }}
                    />
                    <Typography variant="h5">
                      {currentCompany.companyName || "Sin registro"}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {currentCompany.companyCity || "Sin registro"}
                    </Typography>
                  </Box>
                </CardContent>
                <Divider />
              </Card>
              {!isMdUp && (
                <Drawer
                  variant="temporary"
                  open={mobileOpen}
                  onClose={handleDrawerToggle}
                  ModalProps={{ keepMounted: true }}
                  sx={{
                    "& .MuiDrawer-paper": {
                      width: DRAWER_WIDTH,
                      boxSizing: "border-box",
                    },
                  }}
                >
                  {drawer}
                </Drawer>
              )}
              {isMdUp && (
                <Grid2
                  item
                  md="auto" // solo toma el ancho del drawer
                  sx={{ width: "100%" }}
                >
                  <Drawer
                    variant="permanent"
                    open // ← sigue siendo “permanente”
                    //      disablePortal // ← evita que se salga al <body>
                    sx={{
                      // ← estilos al contenedor raíz
                      position: "relative", //   deja de ser fixed
                      flexShrink: 0,
                      width: "100%",
                    }}
                    PaperProps={{
                      sx: {
                        position: "relative", // ← hoja interna también relativa
                        width: "100%",
                        boxSizing: "border-box",
                      },
                    }}
                  >
                    {drawer}
                  </Drawer>
                </Grid2>
              )}
            </Grid2>

            <Grid2
              sx={{
                width: {
                  xs: "100%",
                  sm: "100%",
                  md: "100%",
                  lg: "100%",
                  xl: "100%",
                },
              }}
            >
              {renderContent()}
              {/* <Fromcompanywiew company={currentCompany} userUid={userData.uid} /> */}
            </Grid2>

            {/* <Grid2 item xs={12} sm={6} md={12} lg={4} xl={4}>
             <FileUploadRut
               userUid={userData.uid}
               authorized={authorized}
               prefix={"rut"}
               prefixf={"companies"}
               title={"Rut"}
               descripcion={
                 "Rut del representante legal de la empresa (Pdf, Jpg)"
               }
               objRef="imagen"
               companyUid={userData.userCompanyID}
               defaultImg={currentCompany.companyImgRut}
               status={currentCompany.statusDocsRut}
             />

           </Grid2> */}
          </Box>
        ) : (
          <Grid2 item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Typography variant="h6" color="textSecondary">
              No estás registrado en una empresa.
            </Typography>
            <Box
              sx={{ display: "flex", mb: 1, justifyContent: "space-between" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleRequestAccess}
              >
                Solicitar acceso a una empresa
              </Button>
              <Button
                variant="contained"
                color="secondary"
                sx={{ ml: 2 }}
                onClick={toggleChildTrigger}
              >
                Registrar nueva empresa
              </Button>
            </Box>
            {!viewRegister && !ViewFindCompany && requestDocs?.length > 0 ? (
              <Box sx={{ m: 1 }}>
                <Typography variant="h6" color="#f8f8f8">
                  Solicitudes enviadas
                </Typography>
                <List>
                  {requestDocs.map((request, index) => (
                    <ListItem
                      key={index}
                      sx={{
                        backgroundColor: "#f8f8f8",
                        p: 1,
                        borderRadius: "8px",
                        m: 1,
                      }}
                    >
                      <ListItemText
                        primary={request.companyName}
                        sx={{ m: 1 }}
                      />
                      <Chip
                        label={request.status}
                        color={
                          request.status === "Pendiente"
                            ? "warning"
                            : request.status === "Aceptado"
                            ? "success"
                            : "error"
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            ) : null}
            {viewRegister ? (
              <Fromcompanynew
                company={currentCompany}
                userUid={userData.uid}
                togglechildtrigres={toggleChildTrigger}
              />
            ) : null}
            {ViewFindCompany ? (
              <FromFindCompany
                userId={userData.uid}
                userName={userData.userName}
                email={userData.email}
              ></FromFindCompany>
            ) : null}
          </Grid2>
        )}
      </Grid2>
    </Grid2>
  ) : (
    <LinearProgress />
  );
};

export default Companies;
